<template>
  <div>
    <b-button @click="isModalActive = true" type="is-info">{{
      $t('Previsualizar')
    }}</b-button>
    <b-modal :active.sync="isModalActive">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <VueObjectView v-model="obj" />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueObjectView from 'vue-object-view'

export default {
  name: 'ObjectViewer',
  props: ['obj'],
  components: { VueObjectView },
  data: function() {
    return { isModalActive: false }
  },
  computed: {},

  methods: {}
}
</script>
